// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3l5G0","unreadBadge":"styles_unreadBadge__1p5rP","modalContent":"styles_modalContent__1iAib","modal":"styles_modal__2dzuC"};